<template>
    <div class="notification-item">
        <div class="notification-item__image">
            <img width="55"
                 height="55"
                 loading="lazy"
                 :src="props.notification.img"
                 :alt="props.notification.title"
                 :title="props.notification.title">
        </div>
        <div class="d-flex flex-column justify-content-center text-left ml-2 py-2">
            <h6 class="mb-1">
                {{ props.notification.title }}
            </h6>
            <p class="mb-1">
                {{ props.notification.subtitle }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { NotificationType } from '../types/types';

    interface Props {
        notification: NotificationType;
    }
    const props = defineProps<Props>();
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;

.notification-item {
    display: flex;
    min-width: 300px;
    cursor: pointer;

    &:hover {
        border-radius: 16px;
        background-color: legacyVariables.$whisper;
    }

    &__image {
        display: flex;
        align-items: center;
        padding: 4px;
    }

    h6 {
        color: legacyVariables.$body-color;
        font-size: 13px;
    }

    p {
        color: legacyVariables.$name-pill;
        font-size: 10px !important; //Overwrite global styling
        font-weight: 500;

    }
}

.dark-theme {
    .notification-item {
        &:hover {
            background: legacyVariables.$pastel-purple;
        }

        h6 {
            color: variables.$baseWhite;
        }

        p {
            color: variables.$baseWhite;
        }
    }
}
</style>
